import { render } from "./ZahlungsInformationen.vue?vue&type=template&id=32ad117a"
import script from "./ZahlungsInformationen.vue?vue&type=script&lang=js"
export * from "./ZahlungsInformationen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__